module.exports = __webpack_public_path__ + "static/background-36bdd479218ff5bf85fbe6f834ed25ed.jpg";